export default "__VITE_ASSET__CUnbZM3Y__"